module.exports = __webpack_public_path__ + "static/logo_icon-a7c5cb87d8b68c8b9748bc30459ff432.png";